import { useTranslation } from "react-i18next";

import { Form } from "react-bootstrap";

function TravelInvoiceForm({ travelInvoice, setTravelInvoice }) {
  const { t } = useTranslation();

  return (
    <div className="invoice-page__modal_form_invoice-container">
      <Form.Group>
        <Form.Label>Pay de Destination: </Form.Label>
        <Form.Control
          label="text"
          value={travelInvoice.destination_country}
          onChange={(e) =>
            setTravelInvoice({
              ...travelInvoice,
              destination_country: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Date de naissance: </Form.Label>
        <Form.Control
          label="date de naissance"
          type="date"
          value={travelInvoice.date_of_birth}
          onChange={(e) =>
            setTravelInvoice({
              ...travelInvoice,
              date_of_birth: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Duree du voyage:</Form.Label>
        <Form.Control
          label="Duree du voyage"
          value={travelInvoice.duration}
          placeholder="Duree du voyage en jours ex. 90 jours"
          onChange={(e) =>
            setTravelInvoice({ ...travelInvoice, duration: e.target.value })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Photo du passport: </Form.Label>
        <Form.Control
          label="Passport picture:"
          type="file"
          accept="image/*"
          placeholder="Une photo du passport. Format uniquement en png ou jpeg. Pas de PDF"
          onChange={(e) =>
            setTravelInvoice({ ...travelInvoice, passport: e.target.files[0] })
          }
        />
      </Form.Group>
    </div>
  );
}

export default TravelInvoiceForm;
